import { Country } from '@superbet-group/web.types';
import { Bonus } from '@core/models/bonus/Bonus';
import BonusDto from '@app/promotionHub/bonuses/types/betlerDto/BetlerBonusDto';

import { transformBetlerBonus } from './transformBetlerBonus';
import { transformComtradeBonus } from './transformComtradeBonus';
import { ComtradeBonusDto } from '@app/promotionHub/bonuses/types/comtradeDto/ComtradeBonusDto';

export const transformBonus: Record<Country, (bonus: any) => Bonus> = {
    [Country.Ro]: (bonus: ComtradeBonusDto) => transformComtradeBonus(bonus),
    [Country.RoNapoleon]: (bonus: BonusDto) => transformBetlerBonus(bonus),
    [Country.Pl]: (bonus: ComtradeBonusDto) => transformComtradeBonus(bonus),
    [Country.Com]: (bonus: BonusDto) => transformBetlerBonus(bonus),
    [Country.Br]: (bonus: BonusDto) => transformBetlerBonus(bonus),
    [Country.BrSocial]: (bonus: BonusDto) => transformBetlerBonus(bonus),
    [Country.Rs]: (bonus: BonusDto) => transformBetlerBonus(bonus),
    [Country.Be]: (bonus: BonusDto) => transformBetlerBonus(bonus),
    [Country.Bg]: (bonus: BonusDto) => transformBetlerBonus(bonus),
};
